<div #timeline class="timeline">
  <div class="timeline__toolbar">
    <div class="timeline__container  toolbar__container">

      <div class="timeline__user-details">
        <div class="timeline__username">
          <div class="timeline__usericon"></div> {{ timelineStudent.studentFullName }}
        </div>
        <div class="timeline__subject timeline__subject--desktop" (click)="openSubjectModal()"><span class="timeline__subject-text">{{ subject }}</span></div>
      </div>

      <div class="timeline__calendar">
        @if (timelineDateFrame != null) {
          <app-timeline-nav #nav [timelineDateFrame]="timelineDateFrame" (onBackClick)="backClick($event)">
            <div class="timeline__subject  timeline__subject--mobile" (click)="openSubjectModal()"><span class="timeline__subject-text">{{ subject }}</span></div>
          </app-timeline-nav>
        }
      </div>

      <div class="timeline-nav__ctrls">
        <div class="timeline-nav__back" (click)="backClick()">Close</div>
      </div>

    </div>
  </div>

  <div class="timeline__container">
    <div class="timeline__sections">
      @for (timelineSection of timelineList; track timelineSection; let last = $last) {
        <section-base #sections
          [placementId]="placementId"
          [student]="timelineStudent"
          [timelineSection]="timelineSection"
          [last]="last"
          [subject]="subject"
          (dataChanged)="refreshTimeline($event)"
        ></section-base>
      }
    </div>

  </div>
</div>
